import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import '../../../assets/css/modal.css'
import './TCModalTournament.css'
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import tcImage from './tc.png'

const TCModalTournament = ({ showTCModalTournament, setShowTCModalTournament }) => {
  const { token, setToken, playerData, setPlayerData } = useContext(dataContext);
  
  function hideModalOperation() {
    setShowTCModalTournament(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("termsConditions", msisdn);
    analyticEvent('termsConditions', 'termsConditions-view')
  }, [])

  return (
    <>
      <Modal show={showTCModalTournament} centered dialogClassName="modal-dialog" contentClassName="modalContentTcModalTournament" onHide={hideModalOperation}>
        <Modal.Header closeButton >
          <Modal.Title>শর্তাবলী</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "45vh", maxHeight: '525px', overflow: "scroll", display: 'block', overflowX: 'hidden' }}>
        <div className="quizard-rules-container">
      <h4 className="rules-heading">Quizard এ কীভাবে যোগদান করবেন:</h4>
      <p className="rules-paragraph">
        সাপ্তাহিক ৩০ টাকা চার্জে কুইজ প্রতিদিন, স্পোর্টস কুইজ, BCS প্রস্তুতি  এবং টুর্নামেন্ট ৩০ টাকা চার্জে কুইজ গুলো তে আপনি কুইজ খেলতে পারবেন | বিকাশ পেমেন্ট এর মাধ্যমে ব্যবহারকারীরা তাদের অ্যাকাউন্টটির সাবস্ক্রিপশন সম্পন্ন করতে পারবেন আর QUIZARD এ যোগদান করতে পারবেন ।
      </p>

      <h5 className="sub-heading">কুইজ খেলার নিয়ম :</h5>
      <ul className="rules-list">
        <li>QUIZARD কুইজ গেমটিতে কুইজ প্রতিদিন, একাধিক টুর্নামেন্ট কুইজ এর পাশাপাশি ক্যাটাগরি কুইজের একাধিক সেগমেন্টে কুইজ খেলার সুযোগ থাকবে ।</li>
        <li>QUIZARD এর প্রতিটি সেগমেন্টে সর্বোচ্চ ৬০ টি পছন্দের প্রশ্ন থাকবে এবং দৈনিক ২ বার খেলা যাবে ।</li>
        <li>প্রতি রাউন্ড এ অংশগ্রহণকারীদের প্রদত্ত বিকল্পগুলি থেকে সঠিক উত্তর নির্বাচন করতে হবে। অংশগ্রহণকারীরা প্রতিটি সঠিক উত্তরের জন্য ১ পয়েন্ট অর্জন করবে।</li>
        <li>কুইজ এর উত্তর জমা দেওয়ার জন্য একটি নির্দিষ্ট সময়সীমা থাকবে।</li>
        <li>দুটি রাউন্ড এর মধ্যে যে রাউন্ড এর স্কোর বেশি হবে, সেটিই ফাইনাল স্কোর হিসেবে গণনা করা হবে ।</li>
      </ul>

      <h5 className="sub-heading">বিজয়ীদের পুরস্কার :</h5>
      <p className="rules-paragraph">
        <strong>বিশেষ দ্রষ্টব্য:</strong> একটি নির্দিষ্ট bKash নম্বর দিয়েই Quizard-এর ৪টি দারুন সেগমেন্টে সাবস্ক্রিপশন করতে পারবেন <br/>
        কুইজ প্রতিদিন  |  স্পোর্টস কুইজ |  BCS প্রস্তুতি  |  কুইজ টুর্নামেন্ট ! <br/>
        তবে মনে রাখবেন, ওই bKash নম্বরের সাবস্ক্রিপশনগুলো থেকে প্রতি সেগমেন্টে শুধু একটি নম্বরই উইনার হিসেবে নির্বাচিত হবে! <br/>
        QUIZARD কর্তৃপক্ষ বিজয়ীদের দৈনিক, সাপ্তাহিক, টুর্নামেন্ট ভিত্তিক পুরস্কার প্রদান করে থাকে ।
      </p>
      <ul className="rewards-list">
        <li>
          <strong>কুইজ প্রতিদিন পুরস্কার:</strong><br/>
          প্রতিদিন: শীর্ষ ৫০ জন ১০ টাকা bKash ক্যাশ-ইন<br/>
          সাপ্তাহিক : শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত bKash ক্যাশ-ইন
        </li>
        <li>
          <strong>স্পোর্টস কুইজ পুরস্কার:</strong><br/>
          প্রতিদিন: শীর্ষ ৪০ জন ১০ টাকা bKash ক্যাশ-ইন<br/>
          সাপ্তাহিক: শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত
        </li>
        <li>
          <strong>BCS প্রস্তুতি পুরস্কার:</strong><br/>
          প্রতিদিন: শীর্ষ ৩০ জন ১০ টাকা bKash ক্যাশ-ইন<br/>
          সাপ্তাহিক: শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত
        </li>
        <li>
          <strong>Tournament Quiz:</strong> টুর্নামেন্ট ফরম্যাটে মেগা পুরস্কার<br/>
          প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা bKash ক্যাশ-ইন<br/>
          <ul>
            <li><strong>১ম পুরস্কার:</strong> টিভি (Samsung 32T4450 32" HD LED Smart TV)</li>
            <li><strong>২য় পুরস্কার:</strong> স্মার্টফোন (Samsung Galaxy A16 5G (6/128 GB))</li>
            <li><strong>৩য় পুরস্কার:</strong> স্মার্টওয়াচ</li>
            <li><strong>৪র্থ পুরস্কার:</strong> ৩০০০ টাকা ক্যাশ ইন</li>
            <li><strong>৫ম পুরস্কার:</strong> ২০০০ টাকা ক্যাশ ইন পুরস্কার</li>
          </ul>
        </li>
      </ul>

      <h5 className="sub-heading">Quizard এ অন্যান্য পুরস্কার :</h5>
      <ul className="rewards-list">
        <li>কুইজ প্রতিদিন, স্পোর্টস কুইজ, BCS প্রস্তুতি ও টুর্নামেন্ট বান্ডেল সাবস্ক্রাইব করলে ২০% ক্যাশব্যাক</li>
        <li>রেফারেল সফল হলে উভয় পক্ষ ১০ টাকা ক্যাশ-ইন পাবে</li>
        <li>ফিরে আসা ইউজারদের জন্য ১০ টাকা ক্যাশব্যাক</li>
        <li>নিউ সাবস্ক্রাইবার গন পাবেন ৫ টাকা ক্যাশ ব্যাক প্রাইজ</li>
      </ul>
    </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default TCModalTournament